import { render, staticRenderFns } from "./TripleIconMessage.vue?vue&type=template&id=2449eeea&"
import script from "./TripleIconMessage.vue?vue&type=script&lang=js&"
export * from "./TripleIconMessage.vue?vue&type=script&lang=js&"
import style0 from "./TripleIconMessage.vue?vue&type=style&index=0&id=2449eeea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports